import {Page} from '@vio/core/src/analytics/types/Events'
// eslint-disable-next-line
import {brands} from '@vio/core/src/brand/config'
import {Brand, BrandCode} from '@vio/core/src/brand/types'
import {getIsProductionAppEnv} from '@vio/core/src/utils/environment'

type CanonicalBrand = {
  code: BrandCode
  siteAddresses: Brand['siteAddresses']
  capabilities: {search: {indexesHomepageOnly: boolean}}
}

const canonicalUrlsMapProduction: Partial<
  Record<BrandCode, Partial<Record<Page, string>>>
> = {
  vio: {
    [Page.Home]: brands.vio.siteAddresses.address
  }
}

const canonicalUrlsMapStaging: Partial<
  Record<BrandCode, Partial<Record<Page, string>>>
> = {
  vio: {
    [Page.Home]: brands.vio.environmentAddresses?.stagingAddress
  }
}

/** Off production there is nothing safe to point at, so no canonical at all. */
const getHomepageOnlyCanonicalUrl = (
  brand: CanonicalBrand,
  page: Page,
  isProduction: boolean
) => {
  if (page !== Page.Home || !brand.capabilities.search.indexesHomepageOnly) {
    return undefined
  }
  if (!isProduction) {
    return undefined
  }

  return new URL(brand.siteAddresses.address).href
}

export const getCanonicalUrl = (brand: CanonicalBrand, page?: Page) => {
  if (!page) {
    return undefined
  }

  const isProduction = getIsProductionAppEnv(process.env.NEXT_PUBLIC_ENV)
  const canonicalUrlsMap = isProduction
    ? canonicalUrlsMapProduction
    : canonicalUrlsMapStaging
  const canonicalUrl = canonicalUrlsMap[brand.code]?.[page]

  return canonicalUrl ?? getHomepageOnlyCanonicalUrl(brand, page, isProduction)
}
